<template>
  <div>
    <horizontal-histogram
      v-if="mobilePhone"
      :key="`${chamber}-histogram-${currentDate}`"
      :chamber="chamber"
      :majority="majority"
      :gopProb="probabilityOfGopMajority"
      :movement="modelMovement"
      :simulations="chamber === 'house' ? houseModel.simulations : senateModel.simulations">
    </horizontal-histogram>
    <histogram
      v-else
      :key="`${chamber}-histogram-${currentDate}`"
      :chamber="chamber"
      :majority="majority"
      :gopProb="probabilityOfGopMajority"
      :movement="modelMovement"
      :simulations="chamber === 'house' ? houseModel.simulations : senateModel.simulations">
    </histogram>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { Histogram, HorizontalHistogram } from '@/components/charts'

const components = {
  Histogram,
  HorizontalHistogram
}

const props = {
  chamber: {
    type: String,
    required: true
  }
}

const computed = {
  ...mapGetters({
    models: 'aggregateModels/list',
    dates: 'aggregateModels/dates',
    mobilePhone: 'ux/mobilePhone',
    currentDate: 'aggregateModels/currentDate'
  }),
  houseModels () {
    return this.models.filter(model => model.chamber === 'HOUSE')
  },
  houseModel () {
    return this.houseModels.find(model => model.date === this.currentDate)
  },
  senateModels () {
    return this.models.filter(model => model.chamber === 'SENATE')
  },
  senateModel () {
    return this.senateModels.find(model => model.date === this.currentDate)
  },
  probabilityOfGopMajority () {
    if (this.chamber === 'senate') {
      return (this.senateModel.probabilityOfGopMajority * 100).toFixed(1) + '%'
    } else if (this.chamber === 'house') {
      return (this.houseModel.probabilityOfGopMajority * 100).toFixed(1) + '%'
    }
  },
  majority () {
    return this.chamber === 'house' ? 218 : 50
  }
}

const methods = {
  getModelMovement (models, key) {
    const index = this.dates.indexOf(this.currentDate)
    const current = models.find(model => model.date === this.currentDate)
    const prev = models.find(model => model.date === this.dates[index - 1])
    if (prev && index > 0) {
      let diff = Math.round((current[key] - prev[key]) * 10000) / 100
      diff = diff.toString()
      let party = {
        diff: null,
        party: null
      }

      if (diff.includes('-')) {
        party = 'Democrats'
        diff = diff.replace('-', '')
      } else {
        party = 'Republican'
      }
      this.modelMovement.diff = diff
      this.modelMovement.party = party.charAt(0)
    } else {
      this.modelMovement.diff = null
    }
  }
}

export default {
  components,
  props,
  computed,
  methods,
  data () {
    return {
      modelMovement: {
        diff: null,
        party: null
      }
    }
  },
  mounted () {
    if (this.chamber === 'senate') {
      this.getModelMovement(this.senateModels, 'probabilityOfGopMajority')
    } else if (this.chamber === 'house') {
      this.getModelMovement(this.houseModels, 'probabilityOfGopMajority')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/ChamberHistogram.vue